import {Component,EventEmitter,Input,OnInit,Output,ViewChild} from '@angular/core';
import {BsModalService,ModalDirective} from 'ngx-bootstrap';

@Component({
  selector: 'jhi-user-confirmation-modal',
  templateUrl: './user-confirmation-modal.component.html'
})
export class UserConfirmationModalComponent implements OnInit {

  @ViewChild("changeModal") changeModal: ModalDirective
  
  @Input() openModal: boolean
  @Input() title: string;
  @Input() message: string;
  
  @Output() cancel=new EventEmitter<any>();
  @Output() submit=new EventEmitter<any>();

  constructor(public modalService: BsModalService) { }

  ngOnInit() {
    if(this.title==null) {
      this.title='Confirmation Modal';
    }
    if(this.openModal) {
      this.changeModal.show()
    }

  }

  hideModal() {
    this.changeModal.hide();
  }

  onCancel() {
    this.cancel.emit(true);
    this.hideModal();
  }

  onConfirm() {
    this.submit.emit(true);
    this.hideModal();
  }

}
